import { useEffect, useRef, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import api from '@/lib/api';

export const SETTINGS = [
  ['Target & mode', [
    ['mode', 'Mode mancing', 'mode'],
    ['bot_username', 'Bot Fish It (username DM)', 'text'],
    ['group_username', 'Grup target', 'text'],
  ]],
  ['Waktu', [
    ['group_join_delay_ms', 'Jeda sebelum JOIN (ms)', 'number', 0, 60000],
    ['post_inventory_delay_ms', 'Jeda setelah inventory (ms)', 'number', 0, 60000],
    ['group_fish_seconds', 'Durasi mancing grup (detik)', 'number', 0],
    ['vip_fish_seconds', 'Durasi mancing VIP (detik)', 'number', 0],
    ['vip_gap_seconds', 'Jeda antar VIP (detik)', 'number', 0],
    ['extract_sell_every_n_fish', 'Jual setiap N sesi mancing', 'number', 1],
    ['inventory_page_size', 'Item per halaman inventory', 'number', 1],
  ]],
  ['Extract Inventory', [
    ['extract_artifacts', '🟢 Extract Artefak', 'bool'],
    ['extract_secret', '🔵 Extract Secret', 'bool'],
    ['extract_secret_shiny', '🟣 Extract Secret Shiny', 'bool'],
  ]],
  ['Otomatis harian & misi', [
    ['auto_claim_daily_missions', 'Klaim Misi Harian & Mingguan', 'bool'],
    ['auto_claim_special_missions', 'Klaim Misi Special', 'bool'],
    ['auto_clan_donation', 'Auto Donasi Clan', 'bool'],
    ['auto_bait_purchase', 'Auto Beli Umpan', 'bool'],
  ]],
  ['Mancing & boost', [
    ['open_mancing', 'Open Mancing', 'bool'],
    ['auto_pin_registration', 'Pin Pendaftaran', 'bool'],
    ['boost_group', 'Boost Group', 'bool'],
    ['boost_private', 'Boost Private', 'bool'],
    ['extra_allowed_chats', 'Chat tambahan (pisahkan koma)', 'text'],
    ['boost_command', 'Perintah boost DM', 'text'],
    ['group_boost_command', 'Perintah boost grup', 'text'],
    ['boost_cooldown_seconds', 'Cooldown boost (detik)', 'number', 0],
  ]],
];

export default function BulkConfiguration({ onBusyChange }) {
  const [options, setOptions] = useState(null);
  const [selected, setSelected] = useState([]);
  const [fields, setFields] = useState([]);
  const [values, setValues] = useState({});
  const [search, setSearch] = useState('');
  const [source, setSource] = useState('');
  const [loadedSource, setLoadedSource] = useState(null);
  const [history, setHistory] = useState([]);
  const [historyError, setHistoryError] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [results, setResults] = useState([]);
  const [progress, setProgress] = useState('');
  const alive = useRef(true);
  const running = useRef(false);
  const refreshHistory = async () => {
    try {
      const { data } = await api.get('/automation/config/bulk-history');
      if (alive.current) { setHistory(data.history || []); setHistoryError(''); }
    } catch { if (alive.current) setHistoryError('Riwayat belum dapat dimuat.'); }
  };
  useEffect(() => { onBusyChange?.(busy); }, [busy, onBusyChange]);
  useEffect(() => {
    alive.current = true;
    api.get('/automation/config/bulk-options').then(({ data }) => {
      if (alive.current) { setOptions(data); setValues(data.defaults); }
    }).catch(() => { if (alive.current) setError('Daftar akun belum dapat dimuat. Buka kembali halaman ini.'); });
    void refreshHistory();
    return () => { alive.current = false; };
  }, []);
  useEffect(() => {
    const before = (event) => {
      if (running.current) { event.preventDefault(); event.returnValue = ''; }
    };
    window.addEventListener('beforeunload', before);
    return () => window.removeEventListener('beforeunload', before);
  }, []);
  const toggle = (list, key, checked) => checked ? [...new Set([...list, key])] : list.filter((v) => v !== key);
  const update = (key, value) => setValues((old) => ({ ...old, [key]: value }));
  const apply = async () => {
    if (running.current || !selected.length || !fields.length) return;
    if (source && loadedSource?.id !== source) {
      setError('Baca konfigurasi akun sumber yang dipilih sebelum menerapkan.'); return;
    }
    const changes = Object.fromEntries(fields.map((key) => [key, values[key]]));
    if (Object.values(changes).some((value) => value == null
        || typeof value === 'number' && !Number.isInteger(value))) {
      setError('Isi semua pengaturan yang dicentang dengan nilai yang valid.'); return;
    }
    running.current = true; setBusy(true); setError(''); setResults([]);
    const targetIds = [...selected];
    const operationId = globalThis.crypto?.randomUUID?.() || 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.floor(Math.random() * 16); return (c === 'x' ? r : (r & 3) | 8).toString(16);
    });
    try {
      // One account per request keeps progress and uncertain results visible.
      for (let i = 0; i < targetIds.length && alive.current; i++) {
        const id = targetIds[i];
        setProgress(`Menerapkan ${i + 1} dari ${targetIds.length} akun…`);
        try {
          const { data } = await api.post('/automation/config/bulk', { account_ids: [id], changes,
            operation_id: operationId, source_account_id: loadedSource?.id || null });
          if (!alive.current) break;
          const result = data.results?.find((row) => row.account_id === id);
          if (!result) throw new Error('Unconfirmed');
          setResults((old) => [...old, result]);
          if (result.status === 'saved') setSelected((old) => old.filter((key) => key !== id));
          if (['unknown', 'changed_again'].includes(result.status)) {
            setError('Proses ditahan. Periksa hasil akun ini; akun berikutnya belum diubah.'); break;
          }
        } catch (err) {
          if (!alive.current) break;
          const status = err?.response?.status;
          const certainRejection = [400, 401, 403, 404, 422].includes(status);
          setResults((old) => [...old, { account_id: id, status: certainRejection ? 'failed' : 'unknown',
            message: certainRejection ? 'Permintaan ditolak. Periksa nilai dan akses akun.'
              : 'Hasil belum terkonfirmasi. Periksa konfigurasi akun sebelum mencoba lagi.' }]);
          setError('Proses dihentikan. Akun berikutnya belum diubah.');
          break;
        }
      }
    } finally {
      running.current = false;
      if (alive.current) { setBusy(false); setProgress(''); }
      if (alive.current) void refreshHistory();
    }
  };
  const loadSource = async (all = false) => {
    if (!source || busy) return;
    setBusy(true); setError('');
    try {
      const { data } = await api.get('/automation/config', { headers: { 'X-Account-Id': source } });
      if (alive.current) {
        setValues((old) => ({ ...old, ...Object.fromEntries(options.fields.map((key) => [key, data[key]])) }));
        setLoadedSource({ id: source, label: options.accounts.find((a) => a.id === source)?.label || source });
        if (all) setFields([...options.fields]);
      }
    } catch { if (alive.current) setError('Konfigurasi sumber belum dapat dibaca.'); }
    finally { if (alive.current) setBusy(false); }
  };
  if (!options) return <div role="status">{error || 'Memuat daftar akun…'}</div>;
  const visible = options.accounts.filter((a) => (a.label || a.id).toLowerCase().includes(search.toLowerCase()));
  const label = (id) => options.accounts.find((a) => a.id === id)?.label || id;
  const titles = Object.fromEntries(SETTINGS.flatMap(([, rows]) => rows.map(([key, title]) => [key, title])));
  const showValue = (value) => typeof value === 'boolean' ? (value ? 'ON' : 'OFF') : String(value ?? '') || '(kosong)';
  return <div className="space-y-6" data-testid="bulk-config-page">
    <div>
      <h1 className="font-heading text-2xl font-bold">Edit banyak akun</h1>
      <p className="mt-2 text-sm text-slate-400">Pilih akun dan centang pengaturan yang ingin disamakan. Pengaturan lainnya tetap mengikuti masing-masing akun.</p>
    </div>
    <fieldset disabled={busy} className="rounded-2xl border border-white/10 bg-[#0F0F16] p-4 space-y-3">
      <legend className="font-semibold px-2">1. Pilih akun ({selected.length} dipilih)</legend>
      <Input aria-label="Cari akun" placeholder="Cari nama akun" value={search} onChange={(e) => setSearch(e.target.value)} />
      <div className="flex gap-2">
        <Button type="button" variant="outline" onClick={() => setSelected(options.accounts.map((a) => a.id))}>Pilih semua akun</Button>
        <Button type="button" variant="outline" onClick={() => setSelected([])}>Kosongkan pilihan</Button>
      </div>
      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-2 max-h-72 overflow-y-auto">
        {visible.map((account) => <label key={account.id} className="flex items-center gap-2 border border-white/10 rounded-lg p-3 cursor-pointer">
          <input type="checkbox" aria-label={`Pilih akun ${account.label || account.id}`} checked={selected.includes(account.id)}
            onChange={(e) => setSelected((old) => toggle(old, account.id, e.target.checked))} />
          <span>{account.label || account.id}</span>
        </label>)}
      </div>
      {!visible.length && <p className="text-sm text-slate-400">Tidak ada akun yang cocok.</p>}
    </fieldset>
    <fieldset disabled={busy} className="rounded-2xl border border-white/10 bg-[#0F0F16] p-4 space-y-5">
      <legend className="font-semibold px-2">2. Pilih pengaturan ({fields.length} dicentang)</legend>
      <div className="flex flex-wrap items-end gap-2">
        <label className="text-sm">Isi nilai dari akun (opsional)
          <select className="block mt-1 bg-[#05050A] border border-white/15 rounded-md p-2" aria-label="Akun sumber" value={source} onChange={(e) => setSource(e.target.value)}>
            <option value="">Pilih akun sumber</option>
            {options.accounts.map((a) => <option key={a.id} value={a.id}>{a.label || a.id}</option>)}
          </select>
        </label>
        <Button type="button" variant="outline" disabled={!source || busy} onClick={() => loadSource(false)}>Baca konfigurasi</Button>
        <Button type="button" variant="outline" disabled={!source || busy} onClick={() => loadSource(true)}>Pakai semua pengaturan akun sumber</Button>
      </div>
      <p className="text-xs text-slate-400">Baca konfigurasi mengisi nilai saja. Pakai semua pengaturan juga mencentang seluruh pengaturan yang tersedia. Keduanya baru diterapkan setelah tombol Terapkan ditekan.</p>
      {loadedSource && <p className="text-sm text-cyan-300">Nilai terakhir dibaca dari: {loadedSource.label}</p>}
      {source && loadedSource?.id !== source && <p role="status" className="text-sm text-amber-300">Akun sumber ini belum dibaca. Baca dahulu agar nilai dari sumber sebelumnya tidak ikut diterapkan.</p>}
      <div className="flex gap-2">
        <Button type="button" variant="outline" onClick={() => setFields([...options.fields])}>Pilih semua pengaturan</Button>
        <Button type="button" variant="outline" onClick={() => setFields([])}>Kosongkan pengaturan</Button>
      </div>
      {SETTINGS.map(([heading, rows]) => <section key={heading} className="space-y-3">
        <h2 className="font-semibold text-sm">{heading}</h2>
        {heading === 'Extract Inventory' && <p className="text-xs text-amber-300">Ikan di kategori extract yang aktif akan diubah menjadi material dan hilang permanen. Favorite tidak ikut di-extract.</p>}
        <div className="grid md:grid-cols-2 gap-3">
          {rows.filter(([key]) => options.fields.includes(key)).map(([key, title, type, min, max]) => <div key={key} className="rounded-lg border border-white/10 p-3 space-y-2">
            <label className="flex gap-2 items-center text-sm">
              <input type="checkbox" aria-label={`Ubah ${title}`} checked={fields.includes(key)}
                onChange={(e) => setFields((old) => toggle(old, key, e.target.checked))} />{title}
            </label>
            {type === 'bool' || type === 'mode' ?
              <select aria-label={`Nilai ${title}`} disabled={!fields.includes(key)} value={String(values[key])}
                className="w-full rounded-md bg-[#05050A] border border-white/15 p-2 text-sm disabled:opacity-40"
                onChange={(e) => update(key, type === 'bool' ? e.target.value === 'true' : e.target.value)}>
                {type === 'bool' ? <><option value="true">ON</option><option value="false">OFF</option></>
                  : <><option value="vip_direct">VIP Direct</option><option value="group">Group</option></>}
              </select> : <Input aria-label={`Nilai ${title}`} type={type} min={min} max={max} step={type === 'number' ? 1 : undefined}
                disabled={!fields.includes(key)} value={values[key] ?? ''}
                onChange={(e) => update(key, type === 'number' ? (e.target.value === '' ? null : Number(e.target.value)) : e.target.value)} />}
          </div>)}
        </div>
      </section>)}
    </fieldset>
    <div className="rounded-xl border border-cyan-500/20 bg-cyan-500/5 p-4 space-y-3">
      <p className="text-sm">Terapkan {fields.length} pengaturan ke {selected.length} akun. Bot yang berjalan melanjutkan dengan konfigurasi baru. Akun yang Stop atau dijeda tetap tidak dijalankan.</p>
      {!!fields.length && <div aria-label="Nilai yang akan diterapkan" className="max-h-64 overflow-auto rounded-lg border border-white/10 p-3 space-y-2">
        <p className="font-semibold text-sm">Nilai yang akan diterapkan</p>
        {fields.map((key) => <p key={key} className="text-sm break-words"><span className="text-slate-400">{titles[key] || key}: </span>{showValue(values[key])}</p>)}
      </div>}
      <Button disabled={busy || !selected.length || !fields.length || !!source && loadedSource?.id !== source} onClick={apply} data-testid="apply-bulk-config">{busy ? 'Memproses…' : 'Terapkan ke akun terpilih'}</Button>
      {progress && <p role="status" aria-live="polite">{progress}</p>}
      {error && <p role="alert" className="text-red-300">{error}</p>}
      {!!results.length && <div aria-label="Hasil penerapan" className="space-y-2">
        {results.map((result) => <div key={result.account_id} className="text-sm flex flex-wrap gap-2">
          <strong>{label(result.account_id)}</strong>
          <span className={result.status === 'saved' ? 'text-emerald-300' : 'text-amber-300'}>{result.message}</span>
        </div>)}
        {!busy && <p className="text-xs text-slate-400">Akun yang berhasil sudah dikeluarkan dari pilihan. Anda bisa mencoba kembali akun yang belum diterapkan setelah memeriksa hasilnya.</p>}
      </div>}
    </div>
    <section className="rounded-xl border border-white/10 p-4 space-y-3" aria-label="Riwayat edit massal">
      <div className="flex items-center justify-between gap-2"><h2 className="font-semibold">Riwayat edit massal</h2>
        <Button type="button" variant="outline" disabled={busy} onClick={refreshHistory}>Perbarui riwayat</Button></div>
      <p className="text-xs text-slate-400">20 penerapan terbaru sejak pembaruan ini. Riwayat disimpan 90 hari. Tersimpan dan diperiksa berarti nilai cocok saat pemeriksaan setelah simpan; pengeditan berikutnya tetap dapat mengubahnya.</p>
      {historyError && <p role="alert" className="text-amber-300 text-sm">{historyError}</p>}
      {!history.length && <p className="text-sm text-slate-400">Belum ada riwayat baru.</p>}
      {history.map((row) => <details key={row.id} className="rounded-lg border border-white/10 p-3 text-sm">
        <summary className="cursor-pointer">{row.account_label || label(row.account_id)} · {new Date(row.requested_at).toLocaleString('id-ID', { timeZone: 'Asia/Jakarta' })} WIB · {({ saved: 'Tersimpan dan diperiksa', busy: 'Belum diterapkan: akun sibuk', failed: 'Ditolak', unknown: 'Hasil belum terkonfirmasi', attempting: 'Hasil belum selesai', changed_again: 'Nilai berubah lagi' })[row.status] || row.status}</summary>
        {row.source_label && <p className="mt-2 text-slate-400">Sumber nilai dibaca: {row.source_label}</p>}
        <div className="mt-2 space-y-1">{Object.entries(row.requested_values || {}).map(([key, value]) => <p key={key} className="break-words">{titles[key] || key}: {showValue(value)}{row.observed_after && !Object.is(row.observed_after[key], value) && <span className="text-amber-300"> · Terbaca: {showValue(row.observed_after[key])}</span>}</p>)}</div>
      </details>)}
    </section>
  </div>;
}
